<template>
    <div class="tw-grid tw-duration-300 tw-bg-white  tw-p-4 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-transition-all tw-pt-2 tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-x-4 tw-gap-y-2 lg:tw-grid-cols-4">
        <SpentInFilter v-if="['admin'].includes($user.role)" />
        <MarketerFilter v-if="['admin'].includes($user.role)" />
        <ProductFilter v-if="['admin'].includes($user.role)" />
        <div class="tw-flex tw-justify-end tw-items-end tw-gap-2">
            <a-button @click="onFilter" intent="primary" class="tw-min-w-[100px]">{{ $t('buttons.filter')
            }}</a-button>
            <a-action-button @click="onClearFilter" intent="simple" icon="clarity:filter-off-line"
                class="tw-h-[40px] tw-w-[40px] tw-border-b-2"></a-action-button>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, provide } from 'vue';
import ProductFilter from './filters/ProductFilter.vue';
import SpentInFilter from './filters/SpentInFilter.vue';
import MarketerFilter from './filters/MarketerFilter.vue';

const props = defineProps(['filters', 'visible']);
const emit = defineEmits(['update:filters', 'update:visible', 'filter']);


const visible = computed({
    get: () => props.visible,
    set: v => emit('update:visible', v)
})

const onFilter = () => {
    visible.value = false;
    emit('filter');
}

const onClearFilter = () => {
    visible.value = false;
    emit('update:filters', {})
    emit('filter');
}

provide('filter', ((params = {}) => emit('filter', params)))

</script>

<style></style>